import React from 'react';
import { useNavigation } from '../context/NavigationContext';
import { Footer } from '../components/Footer';
export function PrivacyPage() {
  const {
    navigate
  } = useNavigation();
  return <div className="min-h-screen bg-cream font-sans selection:bg-forest/20 flex flex-col" data-id="element-233">
      <div className="flex-grow max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-234">
        <button onClick={() => navigate('home')} className="text-forest font-medium mb-8 hover:underline flex items-center gap-2" data-id="element-235">
          ← Volver al inicio
        </button>

        <h1 className="text-3xl md:text-4xl font-serif text-charcoal mb-8" data-id="element-236">
          Política de Privacidad
        </h1>

        <div className="prose prose-lg text-charcoal/80 space-y-6" data-id="element-237">
          <p data-id="element-238">Última actualización: {new Date().toLocaleDateString()}</p>

          <h2 className="text-xl font-bold text-charcoal mt-8 mb-4" data-id="element-239">
            1. Recopilación de Información
          </h2>
          <p data-id="element-240">
            Solo recopilamos la información necesaria para procesar tu compra y
            entregar el producto digital. Esto incluye tu nombre y dirección de
            correo electrónico. Los datos de pago son procesados de forma segura
            por nuestros proveedores de pago (Stripe/PayPal) y no almacenamos
            detalles completos de tarjetas de crédito.
          </p>

          <h2 className="text-xl font-bold text-charcoal mt-8 mb-4" data-id="element-241">
            2. Uso de la Información
          </h2>
          <p data-id="element-242">Utilizamos tu correo electrónico para:</p>
          <ul className="list-disc pl-6 space-y-2" data-id="element-243">
            <li data-id="element-244">Enviarte el enlace de descarga del producto.</li>
            <li data-id="element-245">Enviarte el recibo de compra.</li>
            <li data-id="element-246">
              Notificarte sobre actualizaciones importantes del producto (si las
              hubiera).
            </li>
          </ul>

          <h2 className="text-xl font-bold text-charcoal mt-8 mb-4" data-id="element-247">
            3. Protección de Datos
          </h2>
          <p data-id="element-248">
            No vendemos, alquilamos ni compartimos tu información personal con
            terceros para fines comerciales. Tus datos se mantienen
            confidenciales y seguros.
          </p>

          <h2 className="text-xl font-bold text-charcoal mt-8 mb-4" data-id="element-249">
            4. Cookies
          </h2>
          <p data-id="element-250">
            Nuestro sitio web puede utilizar cookies esenciales para el
            funcionamiento del carrito de compras y el proceso de pago. No
            utilizamos cookies de rastreo invasivas.
          </p>
        </div>
      </div>
      <Footer data-id="element-251" />
    </div>;
}